import React, {useEffect, useState} from 'react';

import PropTypes from "prop-types";

import {Dropdown} from "primereact/dropdown";


export function ItemByGroupSelect(props) {
    const handleChange = (event) => {
        const myValue = props.itemList.find(x => x.id === event.target.value)
        props.setItem(myValue);


    };

    return (
            <Dropdown value={props.item.id} onChange={handleChange} options={props.itemList}
                      optionLabel="name" optionValue="id" disabled={props.disable}
                    variant="filled" className="flex w-full md:w-7 h-2rem align-items-center justify-content-center" />


    )

}

ItemByGroupSelect.propTypes = {
    itemList: PropTypes.array.isRequired,
    item: PropTypes.object.isRequired,
    setItem: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,


}
